import React, { useState, useEffect } from 'react';
import './NewspaperRegister.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function NewspaperRegister() {
    const [showNewspaperRegister, setShowNewspaperRegister] = useState(true);
    const [newspapers, setNewspapers] = useState([]);
    const [selectedNewspaper, setSelectedNewspaper] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [daysData, setDaysData] = useState([]);
    const [loadingDaysData, setLoadingDaysData] = useState(false);
    const [errorDaysData, setErrorDaysData] = useState(null);

    useEffect(() => {
        // Fetch the list of newspapers when the component mounts
        const fetchNewspapers = async () => {
            try {
                const response = await fetch(Constants.API_PATH +'newspapers'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error('Failed to fetch newspapers');
                }
                const data = await response.json();
                setNewspapers(data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchNewspapers();
    }, []);

    const fetchDaysData = async () => {
        setLoadingDaysData(true);
        setErrorDaysData(null);
        try {
            const response = await fetch(Constants.API_PATH +'/newspaper_register?newspaperId=${selectedNewspaper}&month=${selectedMonth}&year=${selectedYear}'); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error('Failed to fetch days data');
            }
            const data = await response.json();
            setDaysData(data);
        } catch (error) {
            setErrorDaysData(error.message);
        } finally {
            setLoadingDaysData(false);
        }
    };

    const handleClearSelections = () => {
        setSelectedNewspaper('');
        setSelectedMonth('');
        setSelectedYear('');
        setDaysData([]);
    };

    const handleRegisterDay = (index) => {
        // Logic to register the day (e.g., update the status in the backend)
        console.log(`Registering day: ${index + 1}`);
    };

    const handleExportReport = () => {
        // Logic to export the newspaper report
        console.log('Exporting newspaper report...');
    };

    return (
        showNewspaperRegister && (
            <div className="newspaper-register-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Newspaper Register</span>
                </nav> */}
                <h2 className="section-title">Newspaper Register</h2>
                
                <div className="filters">
                    <div className="filter-group">
                        <label htmlFor="selectNewspaper" className="form-label">Newspaper</label>
                        <SearchableSelect
                            id="selectNewspaper"
                            value={selectedNewspaper}
                            onChange={(e) => setSelectedNewspaper(e.target.value)}
                            options={newspapers.map((newspaper) => ({ value: newspaper.id, label: newspaper.name }))}
                            placeholder="Select Newspaper"
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="selectMonth" className="form-label">Months</label>
                        <SearchableSelect
                            id="selectMonth"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            options={['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(
                                (month) => ({ value: month, label: month })
                            )}
                            placeholder="- Month -"
                        />
                    </div>
                    <div className="filter-group">
                        <label htmlFor="selectYear" className="form-label">Years</label>
                        <SearchableSelect
                            id="selectYear"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            options={[2023, 2024, 2025].map((year) => ({ value: year, label: year }))}
                            placeholder="- Year -"
                        />
                    </div>
                    <button className="search-button" onClick={fetchDaysData}>Search</button>
                    <button className="clear-button" onClick={handleClearSelections}>Clear</button>
                    <button className="export-button" onClick={handleExportReport}>Export Newspaper Report</button>
                </div>

                {loadingDaysData ? (
                    <p>Loading...</p>
                ) : errorDaysData ? (
                    <p>{errorDaysData}</p>
                ) : (
                    <>
                        <div className="days-table">
                            {daysData.map((day, index) => (
                                <div key={index} className={`day-cell ${day.status}`}>
                                    {index + 1}
                                    <button onClick={() => handleRegisterDay(index)}>
                                        {day.status === 'missing' ? (
                                            <span role="img" aria-label="missing">❌</span>
                                        ) : (
                                            <span role="img" aria-label="received">✔️</span>
                                        )}
                                    </button>
                                </div>
                            ))}
                        </div>

                        {/* Register Button */}
                        <button className="register-button">Register</button>
                    </>
                )}
            </div>
        )
    );
}

export default NewspaperRegister;